
import React from 'react'
import {withRouter} from 'react-router'
import deleteSVG from './images/trash-dark.svg'


import Tick from '../ui/Tick.jsx';

const deleteSGVStyle = {
  'width': '2em',
  'margin-top': '1em',
  'margin-left': '.2em'
}

const PracticeUserRow = (props) => {

  const go = ()=>{
    props.router.push('/profile/'+props.user.uid)
  }

  return (<li className="row" key={props.user.uid}>
    <div className="avatar link">
      <a onClick={go}><img src={props.user.picture} alt="Profile pic" /></a>
    </div>
    <div className="row-content row" >
      <div className="fill">
        <a className="link" onClick={go}>
          <nobr className="truncate-mobile">{props.user.name}</nobr><br />
          <small className="truncate-mobile">
            {props.user.email}
          </small>
          </a>
        </div>

        {props.handleToggleParent && <div onClick={(e) => {
          e.stopPropagation(); props.handleToggleParent(props.user._id) }}>
          <Tick label="User" on={props.isParent} ></Tick>
        </div>}
        {props.handleToggleTherapist && <div onClick={(e) => {
          e.stopPropagation();  props.handleToggleTherapist(props.user._id) }}>
          <Tick label="Therapist" on={props.isTherapist} ></Tick>
        </div>}
        {props.remove && <a onClick={(e) => { 
          e.stopPropagation(); props.remove(props.user._id) }}>
          <img src={deleteSVG} style={deleteSGVStyle}/>
          </a>}
      </div>
  </li>)
}

export default withRouter(PracticeUserRow);



// WEBPACK FOOTER //
// ./src/components/practice_admin/PracticeUserRow.jsx